// Blocked users content for the library

import React from 'react';
import { BanIcon } from 'lucide-react';
import { Badge } from '../../../components/ui/badge';
import { Card, CardContent } from '../../../components/ui/card';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '../../../components/ui/empty';
import { Spinner } from '../../../components/ui/spinner';
import type { LibraryBlockedUsersSyncStatus } from '../hooks';
import type { ModSettings } from '@airhead-games/shared/types';

type BlockedUsersContentProps = {
  modSettings: ModSettings;
  syncStatus: LibraryBlockedUsersSyncStatus;
};

const BlockedUsersContent: React.FC<BlockedUsersContentProps> = ({
  modSettings,
  syncStatus,
}) => {
  if (syncStatus === 'syncing') {
    return (
      <div className="flex min-h-36 flex-col items-center justify-center gap-3 text-sm text-muted-foreground">
        <Spinner className="size-5" />
        <span>Syncing…</span>
      </div>
    );
  }

  return (
    <Card>
      <CardContent>
        {modSettings.blockedTwitchUsers.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {modSettings.blockedTwitchUsers.map((blockedUser) => (
              <Badge key={blockedUser.twitchUserId} variant="secondary">
                {blockedUser.twitchLogin}
              </Badge>
            ))}
          </div>
        ) : (
          <Empty>
            <EmptyHeader>
              <EmptyMedia variant="icon">
                <BanIcon />
              </EmptyMedia>
              <EmptyTitle>No blocked users found</EmptyTitle>
              <EmptyDescription>
                No blocked or banned Twitch users were found.
              </EmptyDescription>
            </EmptyHeader>
          </Empty>
        )}
      </CardContent>
    </Card>
  );
};

export default BlockedUsersContent;
